"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const libs_context_lazy_image_1 = require("@hotelplan/libs.context.lazy-image");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const CommonModal_1 = __importStar(require("./CommonModal"));
const ModalWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)(({ fullScreen }) => ({
    maxHeight: fullScreen ? ['calc(100% - 10px)', '100%'] : 'auto',
    height: fullScreen ? '100%' : 'auto',
    bg: 'background',
    display: 'flex',
    flexDirection: 'column',
    bottom: [0, 'auto'],
    width: '100%',
    borderRadius: ['roundedTop', '0px'],
})));
const ModalHeader = styled_components_1.default.div.attrs({
    'data-id': `modal-header`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: 'lightGreySecond',
    flexShrink: 0,
    fontSize: 2,
    py: [2, '14px'],
    px: ['20px', '36px'],
}));
const ModalTitle = styled_components_1.default.h2.attrs({
    'data-id': `title`,
})({
    color: 'inherit',
    fontSize: 'inherit',
});
const ModalControls = styled_components_1.default.div({
    width: '100%',
});
const ModalCloseButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'iconBtn',
    className: 'close-button',
    icon: { name: 'close' },
    'data-id': `close`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    ml: 'auto',
    backgroundColor: 'inherit',
    '.icon': {
        variant: ['icons.md', 'icons.lg'],
    },
    '&:hover,&:focus,&:active': {
        backgroundColor: 'transparent',
        borderColor: 'none',
        svg: {
            fill: 'inherit',
        },
    },
}));
const ModalBody = styled_components_1.default.div.attrs({
    'data-id': `modal-content`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 auto',
    p: 0,
    overflowY: 'auto',
}));
const WhiteBoxModal = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const commonProps = (0, CommonModal_1.useCommonModalBehavior)(props);
    const { title, show, children, onClose, fullScreen = false, controls, } = commonProps;
    const { modalProps, titleProps } = (0, CommonModal_1.getModalAriaProps)(props);
    const scrollBodyRef = (0, react_1.useRef)(null);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(scrollBodyRef, show);
    const showHeader = Boolean(title || props.onClose);
    return (react_1.default.createElement(CommonModal_1.default, Object.assign({}, commonProps),
        react_1.default.createElement(ModalWrapper, Object.assign({ className: "modal-wrapper", fullScreen: fullScreen }, modalProps),
            showHeader ? (react_1.default.createElement(ModalHeader, { className: "modal-header" },
                title && (react_1.default.createElement(ModalTitle, Object.assign({ className: "modal-title" }, titleProps), title)),
                props.onClose ? (react_1.default.createElement(ModalCloseButton, { onClick: onClose }, t('common:close'))) : null)) : null,
            react_1.default.createElement(ModalBody, { className: "modal-body", ref: scrollBodyRef },
                react_1.default.createElement(libs_context_lazy_image_1.LazyImageContainer, { overflow: true, scrollContainer: scrollBodyRef.current || undefined }, children)),
            controls && (react_1.default.createElement(ModalControls, { className: "modal-controls" }, controls)))));
};
exports.default = WhiteBoxModal;
//# sourceMappingURL=WhiteBoxModal.js.map